import { Injectable } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import Swal from 'sweetalert2';
import { PanelDetailMaintenanceComponent } from '../cell-renderer/panel-detail-maintenance/panel-detail-maintenance.component';
import { ActionMaintenanceComponent } from '../cell-renderer/action-maintenance/action-maintenance.component';
import { CurrencyPipe } from '@angular/common';
import localeEsMX from '@angular/common/locales/es-MX';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeEsMX);

@Injectable({
    providedIn: 'root'
})
export class UtilsService {
    private currencyPipe = new CurrencyPipe('es-MX');
    constructor(
    ) { }

    alertSwal(data: any) {
        return Swal.fire({
            title: data.title,
            text: data.text,
            icon: data.icon,
        });
    }
    toastSwal(data: any) {
        return Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            title: data.title,
            text: data.text,
            icon: data.icon,
        });
    }
    alertSwalConfir(data: any) {
        return Swal.fire({
            title: data.title,
            text: data.text,
            icon: data.icon,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: data.btn_confirm
        })
    }
    getDataUser() {
        let dataU: any = localStorage.getItem("dataUser");
        return JSON.parse(dataU)
    }

    private pad2(n: number) { return n < 10 ? `0${n}` : `${n}` }
    public formatCreatedAt(val: any, type:number): string {
        const d = new Date(val)
        if (isNaN(d.getTime())) return ''
        const dd = this.pad2(d.getDate())
        const mm = this.pad2(d.getMonth() + 1)
        const yy = this.pad2(d.getFullYear())
        const hh = this.pad2(d.getHours())
        const mi = this.pad2(d.getMinutes())
        return type === 1 ? `${dd}/${mm}/${yy} ${hh}:${mi}` : `${dd}/${mm}/${yy}`
    }

    columnFolio(expandedIds:any, parent: any, role:string) {
        const folioCol: any = {
            field: 'id',
            headerName: 'Folio',
            cellRendererSelector: (p: ICellRendererParams) => {
                if (p.data && p.data.__isDetail) {
                    return { component: PanelDetailMaintenanceComponent, params: { parent: parent, role: role } } as any;
                }
                return {
                    component: (params: ICellRendererParams) => {
                        const id = params?.data?.id;
                        const expanded = expandedIds.has(id);
                        const icon = expanded ? 'ti-chevron-down' : 'ti-chevron-right';
                        const folio = params?.value ?? '';
                        const createdAt = params?.data?.created_at;
                        const createdAtFmt = this.formatCreatedAt(createdAt, 1);
                        return `
                                <div style="display:flex;align-items:flex-start;gap:6px;line-height:1.2">
                                  <span class="ti ${icon}" style="margin-top:2px"></span>
                                  <div>
                                    <div>${folio}</div>
                                    <div style=\"font-size:11px;color:#6c757d;\">${createdAtFmt}</div>
                                  </div>
                                </div>
                              `;
                    }
                } as any;
            },
            colSpan: (p: any) => {
                if (!(p?.data?.__isDetail)) return 1;
                const left = p.api.getDisplayedLeftColumns ? p.api.getDisplayedLeftColumns().length : 0;
                const center = p.api.getDisplayedCenterColumns ? p.api.getDisplayedCenterColumns().length : 0;
                const right = p.api.getDisplayedRightColumns ? p.api.getDisplayedRightColumns().length : 0;
                return left + center + right;
            },
            cellStyle: (p: any) => {
                if (p?.data?.__isDetail) return { padding: 0 };
                return { display: 'flex', alignItems: 'center', justifyContent: 'left', textAlign: 'left' } as any;
            },
        };
        return folioCol;
    }

    getColummForRolAdminOrSupervisor(expandedIds:any, parent: any, role:string) {
        return [
            this.columnFolio(expandedIds, parent, role),
            {
                field: 'priority.name', headerName: "Prioridad", headerClass: 'text-center-header',
                cellStyle: (params: any) => {
                    const color = params?.data?.priority.color;
                    const textColor = params?.data?.priority.text_color;
                    return { backgroundColor: color, color: textColor, display: 'flex', alignItems: 'center', fontWeight: '600', justifyContent: 'center' } as any;
                },
            },
            { field: 'unit.unit', headerName: "Unidad", headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            { field: 'unit.plates', headerName: "Placas", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'estimated_time_repair_start', headerName: "Fecha inicio de reparación", width: 200,
                cellRenderer: (params: any) => {
                    const date = params?.value;
                    const dateFmt = date ? this.formatCreatedAt(date, 2) : '';
                    return dateFmt;
                }
            },
            { field: 'maintenance_type.name', headerName: "Tipo de mantenimiento", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'maintenance_status.name', headerName: "Estado", 
                width: 150, filter: false, sortable: false, headerClass: 'text-center-header',
                flex: 0,
                cellStyle: (params: any) => {
                    const color = params?.data?.maintenance_status.color;
                    const textColor = params?.data?.maintenance_status.text_color;
                    return { backgroundColor: color, color: textColor, display: 'flex', alignItems: 'center', fontWeight: '600', justifyContent: 'center' } as any;
                },
            },
            {
                field: '', headerName: "Acciones",
                minWidth: 150,
                filter: false,
                sortable: false,
                resizable: false,
                suppressSizeToFit: true,
                headerClass: 'text-center-header',
                cellRenderer: ActionMaintenanceComponent,
                cellStyle: { alignItems: 'left', display: 'flex', justifyContent: 'left' },
                cellRendererParams: { parent: parent, role: role }
            }
        ];
    }
    getColummForRolDirectivo(expandedIds:any, parent: any, role:string) {
        return [
            this.columnFolio(expandedIds, parent, role),
            {
                field: 'priority.name', headerName: "Prioridad", headerClass: 'text-center-header',
                cellStyle: (params: any) => {
                    const color = params?.data?.priority.color;
                    const textColor = params?.data?.priority.text_color;
                    return { backgroundColor: color, color: textColor, display: 'flex', alignItems: 'center', fontWeight: '600', justifyContent: 'center' } as any;
                },
            },
            { field: 'unit.unit', headerName: "Unidad", headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            { field: 'unit.plates', headerName: "Placas", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'estimated_time_repair_start', headerName: "Fecha inicio de reparación", width: 200,
                cellRenderer: (params: any) => {
                    const date = params?.value;
                    const dateFmt = date ? this.formatCreatedAt(date, 2) : '';
                    return dateFmt;
                }
            },
            { field: 'maintenance_type.name', headerName: "Tipo de mantenimiento", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'maintenance_status.name', headerName: "Estado", width: 150, filter: false, sortable: false, headerClass: 'text-center-header',
                flex: 0,
                cellStyle: (params: any) => {
                    const color = params?.data?.maintenance_status.color;
                    const textColor = params?.data?.maintenance_status.text_color;
                    return { backgroundColor: color, color: textColor, display: 'flex', alignItems: 'center', fontWeight: '600', justifyContent: 'center' } as any;
                },
            },
            {
                field: '', headerName: "Acciones",
                minWidth: 150,
                filter: false,
                sortable: false,
                resizable: false,
                suppressSizeToFit: true,
                headerClass: 'text-center-header',
                cellRenderer: ActionMaintenanceComponent,
                cellStyle: { alignItems: 'left', display: 'flex', justifyContent: 'left' },
                cellRendererParams: { parent: parent, role: role }
            }
        ];
    }
    getColummForRolAdministrativo(expandedIds:any, parent: any, role:string) {
        return [
            this.columnFolio(expandedIds, parent, role),
            { field: 'unit.unit', headerName: "Unidad", headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            { field: 'unit.plates', headerName: "Placas", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'payment_request.payment_method.name', headerName: "Forma de pago", width: 200, headerClass: 'text-center-header',
                cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' }
            },
            { field: 'payment_request.payment_type.name', headerName: "Tipo de pago", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'payment_request.amount', headerName: "Costo total", width: 200, filter: false, sortable: false, headerClass: 'text-center-header',
                cellRenderer: (params: any) => {
                    const CostoTotal = params?.value;
                    return this.currencyPipe.transform(CostoTotal, 'MXN', 'symbol', '1.2-2', 'es-MX');
                },
                cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' }
            },
            { field: 'maintenance_type.name', headerName: "Tipo de mantenimiento", width: 120, headerClass: 'text-center-header', cellStyle: { alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            {
                field: 'administrative_status.name', headerName: "Estado", width: 150, filter: false, sortable: false, headerClass: 'text-center-header',
                flex: 0,
                cellStyle: (params: any) => {
                    const color = params?.data?.administrative_status.color;
                    const textColor = params?.data?.administrative_status.text_color;
                    return { backgroundColor: color, color: textColor, display: 'flex', alignItems: 'center', fontWeight: '600', justifyContent: 'center' } as any;
                },
            },
            {
                field: '', headerName: "Acciones",
                minWidth: 150,
                filter: false,
                sortable: false,
                resizable: false,
                suppressSizeToFit: true,
                headerClass: 'text-center-header',
                cellRenderer: ActionMaintenanceComponent,
                cellStyle: { alignItems: 'left', display: 'flex', justifyContent: 'left' },
                cellRendererParams: { parent: parent, role: role }
            }
        ];
    }
}
